import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { H, P } from '@xingternal/malt-typography';
import { PrimaryButtonMedium as Button } from '@xingternal/malt-button';

import PageviewTracker from '../../../Components/PageviewTracker/PageviewTracker';
import StretchButtonGroup from './../../../Components/StretchButtonGroup/StretchButtonGroup';
import FormMessage from './../../../Components/FormMessage/FormMessage';
import FileUpload from './../../../Components/FileUpload/FileUpload';
import Spacer from './../../../Components/Spacer/Spacer';

import messages from './messages';
import FileUploadExpirationModal from './FileUploadExpirationModal';
import FileUploadHowToModal from './FileUploadHowToModal';
import styles from './FileUploadStep.css';

const FileUploadStep = ({
  errors,
  handleFileUploadChange,
  values: { fileUpload },
}) => (
  <>
    <PageviewTracker pageName={'wbm/Welcome/login/recovery/account/verify'} />

    <H level={1}>
      <FormattedMessage {...messages.title} />
    </H>

    <P>
      <FormattedMessage {...messages.description} />
      <FileUploadExpirationModal />
    </P>

    <FileUpload
      value={fileUpload}
      messages={messages}
      onChange={handleFileUploadChange}
    />

    <div className={styles.center}>
      <div className={styles.borderTop} />
      <FileUploadHowToModal />
    </div>

    <Spacer size={4} />

    <FormMessage error={errors.fileUpload} />

    <StretchButtonGroup>
      <Button disabled={!fileUpload || errors.fileUpload} type={'submit'}>
        <FormattedMessage {...messages.buttonContinue} />
      </Button>
    </StretchButtonGroup>
  </>
);

FileUploadStep.propTypes = {
  handleFileUploadChange: PropTypes.func.isRequired,
  values: PropTypes.shape({ fileUpload: PropTypes.any }),
  errors: PropTypes.shape({ fileUpload: PropTypes.any }),
};

export default FileUploadStep;
